<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Serious Adverse Events
      </h2>
      <p class="tw-italic tw-text-gray-700">
        
      </p>
    </b-container>
    <hr>

    <b-card no-body>
      <b-tabs card fill v-model="tabIndex">
        <b-tab v-if="inMyGroups(['Required SAE Acknowledgement'])" :title="'NEEDS YOUR ACKNOWLEDGEMENT ('+events.length+')'" active>
          <b-card-text >
              <b-table
                striped
                hover
                :fields="fields"
                :items="events"
                :tbody-tr-class="rowClickableClass"
                :sort-by.sync="your_sortBy"
                :sort-desc.sync="your_sortDesc"
                @row-clicked="rowClicked"
              >

              <template v-slot:cell(due_on)="data">
                <span class="text-danger" v-if="countdown_timers[data.index].past_due == true" v-html="countdown_timers[data.index].display"></span>
                <span v-if="countdown_timers[data.index].past_due == false" v-html="countdown_timers[data.index].display"></span>
              </template>

              <template v-slot:cell(reports)="data" v-if="inMyGroups(['SAE Report Downloader', 'Required SAE Acknowledgement'])">
                  <b-link v-for="report in data.item.reports" :key="report.id"  style="display: block;"
                      @click="view_report(report)"
                  >{{ report.title }}</b-link>
              </template>
              <template v-slot:cell(reports)="data" v-else>
                  Not authorized to view this report.
              </template>
              <template v-slot:cell(followup_reports)="data" v-if="inMyGroups(['SAE Report Downloader', 'Required SAE Acknowledgement'])">
                  <b-link v-for="report in data.item.followup_reports" :key="report.id" style="display: block;"
                      @click="view_report(report)"
                  >{{ report.title }}</b-link>
              </template>
              <template v-slot:cell(followup_reports)="data" v-else>
                  Not authorized to view this report.
              </template>

              <template v-slot:cell(users_acknowledged)="data">
                <b-row v-for="user in data.item.users_acknowledged" :key="user.user">
                    <b-col cols="6" style="padding-top: 0px; padding-bottom: 0px;" :title="user.timestamp">
                      {{ user.user }}
                    </b-col>
                  
                    <b-col cols="2" style="padding-top: 0px; padding-bottom: 0px;">
                      <i v-if="user.ack == true" class="fa fa-check" style="color: green;"></i>
                    <!-- </b-col>
                    <b-col cols="2" style="padding-top: 0px; padding-bottom: 0px;"> -->
                      <i v-if="user.ack == false && user.is_logged_in_user == false" class="fa fa-times" style="color: red;"></i>
                      <i v-if="user.ack == false && user.is_logged_in_user == true" :id="'user_missing_ack_'+data.index" class="fa fa-times" style="color: red;"></i>
                    </b-col>
                    <b-col cols="4" v-if="user.ack == false && user.is_logged_in_user == true" style="padding-top: 0px; padding-bottom: 0px;">
                      <!-- <b-button @click="acknowledge(userindex)" size="sm" variant="success" disabled class="w-20"><i class="fa fa-check-circle" style="color: white;"></i></b-button> -->
                      <!-- <i class="fa fa-check-circle" style="color: green;"></i> -->
                      <!-- <b-link v-b-modal="'sae_modal_'+data.index" :id="'acknowledge_link_'+data.index">Acknowledge</b-link> -->
                    </b-col>
                </b-row>
              </template>
            </b-table>
            <!-- <b-row v-if="totalRows > perPage"> -->
          </b-card-text>
        </b-tab>

        <b-tab :title="'NEEDS TEAM ACKNOWLEDGEMENT ('+team_events.length+')'">
          <b-card-text >
              <b-table
                striped hover
                :fields="fields"
                :items="team_events"
                :sort-by.sync="team_sortBy"
                :sort-desc.sync="team_sortDesc"
              >

              <template v-slot:cell(due_on)="data">
                <span class="text-danger" v-if="approved_countdown_timers[data.index].past_due == true" v-html="approved_countdown_timers[data.index].display"></span>
                <span v-if="approved_countdown_timers[data.index].past_due == false" v-html="approved_countdown_timers[data.index].display"></span>
              </template>

              <template v-slot:cell(reports)="data" v-if="inMyGroups(['SAE Report Downloader', 'Required SAE Acknowledgement'])">
                  <b-link v-for="report in data.item.reports" :key="report.id" style="display: block;"
                      @click="view_report(report)"
                  >{{ report.title }}</b-link>
              </template>
              <template v-slot:cell(reports)="data" v-else>
                  Not authorized to view this report.
              </template>
              <template v-slot:cell(followup_reports)="data" v-if="inMyGroups(['SAE Report Downloader', 'Required SAE Acknowledgement'])">
                  <b-link v-for="report in data.item.followup_reports" :key="report.id" style="display: block;"
                      @click="view_report(report)"
                  >{{ report.title }}</b-link>
              </template>
              <template v-slot:cell(followup_reports)="data" v-else>
                  Not authorized to view this report.
              </template>

              <template v-slot:cell(users_acknowledged)="data">
                <b-row v-for="user in data.item.users_acknowledged" :key="user.user">
                    <b-col cols="6" style="padding-top: 0px; padding-bottom: 0px;" :title="user.timestamp">
                      {{ user.user }}
                    </b-col>
                  
                    <b-col cols="2" style="padding-top: 0px; padding-bottom: 0px;">
                      <i v-if="user.ack == true || user.is_logged_in_user == true" class="fa fa-check" style="color: green;"></i>
                      <i v-if="user.is_logged_in_user == false && user.ack == false" class="fa fa-times" style="color: red;"></i>
                      <!-- <i v-if="user.ack == false && user.is_logged_in_user == true" :id="'user_missing_ack_'+data.index" class="fa fa-times" style="color: red;"></i> -->
                    </b-col>
                    <b-col cols="4" v-if="user.ack == false && user.is_logged_in_user == true" style="padding-top: 0px; padding-bottom: 0px;">
                      <!-- <b-button @click="acknowledge(userindex)" size="sm" variant="success" disabled class="w-20"><i class="fa fa-check-circle" style="color: white;"></i></b-button> -->
                      <!-- <i class="fa fa-check-circle" style="color: green;"></i> -->
                      <!-- <b-link v-b-modal="'sae_modal_'+data.index" :id="'acknowledge_link_'+data.index">Acknowledge</b-link> -->
                    </b-col>
                </b-row>
              </template>
            </b-table>
          </b-card-text>
        </b-tab>

        <b-tab :title="'ACKNOWLEDGED ('+approved_events.length+')'">
          <b-card-text >
            <b-table
              striped
              hover
              :fields="fields"
              :items="approved_events"
              :sort-by.sync="ack_sortBy"
              :sort-desc.sync="ack_sortDesc"
            >
              <template v-slot:cell(due_on)="data">
                <span class="text-danger" v-if="ack_countdown_timers[data.index].past_due == true" v-html="ack_countdown_timers[data.index].display"></span>
                <span v-if="ack_countdown_timers[data.index].past_due == false" v-html="ack_countdown_timers[data.index].display"></span>
              </template>

              <template v-slot:cell(reports)="data" v-if="inMyGroups(['SAE Report Downloader', 'Required SAE Acknowledgement'])">
                  <b-link v-for="report in data.item.reports" :key="report.id"  style="display: block;"
                    @click="view_report(report)"
                  >{{ report.title }}</b-link>
              </template>
              <template v-slot:cell(reports)="data" v-else>
                  Not authorized to view this report.
              </template>
              <template v-slot:cell(followup_reports)="data" v-if="inMyGroups(['SAE Report Downloader', 'Required SAE Acknowledgement'])">
                  <b-link v-for="report in data.item.followup_reports" :key="report.id" style="display: block;"
                    @click="view_report(report)"
                  >{{ report.title }}</b-link>
              </template>
              <template v-slot:cell(followup_reports)="data" v-else>
                  Not authorized to view this report.
              </template>

              <template v-slot:cell(users_acknowledged)="data">
                <b-row v-for="user in data.item.users_acknowledged" :key="user.user">
                  <b-col cols="6" style="padding-top: 0px; padding-bottom: 0px;" :title="user.timestamp">
                    {{ user.user }}
                  </b-col>
                  <b-col cols="2" style="padding-top: 0px; padding-bottom: 0px;">
                    <i v-if="user.ack == true || user.is_logged_in_user == true" class="fa fa-check" style="color: green;"></i>
                    <i v-if="user.is_logged_in_user == false && user.ack == false" class="fa fa-times" style="color: red;"></i>
                  <!-- </b-col>
                  <b-col cols="2" style="padding-top: 0px; padding-bottom: 0px;"> -->
                    <!-- <i v-if="user.is_logged_in_user == false" class="fa fa-times" style="color: red;"></i> -->
                    <!-- <i v-if="user.ack == false && user.is_logged_in_user == true" :id="'user_missing_ack_'+data.index" class="fa fa-times" style="color: red;"></i> -->
                  </b-col>
                  <b-col cols="4" v-if="user.ack == false && user.is_logged_in_user == true" style="padding-top: 0px; padding-bottom: 0px;">
                    <!-- <b-button @click="acknowledge(userindex)" size="sm" variant="success" disabled class="w-20"><i class="fa fa-check-circle" style="color: white;"></i></b-button> -->
                    <!-- <i class="fa fa-check-circle" style="color: green;"></i> -->
                    <!-- <b-link v-b-modal="'sae_modal_'+data.index" :id="'acknowledge_link_'+data.index">Acknowledge</b-link> -->
                  </b-col>
                </b-row>
              </template>
            </b-table>
          </b-card-text>
        </b-tab>

      </b-tabs>
    </b-card>
     
    <b-modal :ref="'sae_modal'" @ok="acknowledge(sae_data)" :ok-title="'Acknowledge'" size="xl">
      <template v-slot:modal-header="{ close }">
        <span>SAE - {{ sae_data.received_on }} </span>      
      </template>

      <h3>SAE Case Data</h3>
      <hr />
      <b-row v-for="(item, key) in sae_data" :key="key">
        <b-col v-if="item != null && key != 'index' && filter(key, item)">
          {{ in_english_please(key) }}:
        </b-col>
        <b-col v-if="item != null && key != 'index' && filter(key, item)">
          {{ item }}
        </b-col>
      </b-row>
      <br /><br />

      <b-row>
        <b-col>
          <h4>Symptoms</h4>
          <hr />
          <span v-if="sae_symptoms == null || sae_symptoms.length == 0" style="font-style: italic;">No Symptoms Reported</span>
          <b-row v-for="symptom in sae_symptoms" :key="symptom">
            <b-col>
              {{ symptom.display }}
            </b-col>
            <b-col>
              {{ symptom.start}}<span v-if="symptom.end"> - {{ symptom.end }}</span>
            </b-col>
          </b-row>
        </b-col>

        <b-col>
          <h4>Diagnoses</h4>
          <hr />
          <span v-if="sae_diagnosis == null || sae_diagnosis.length == 0" style="font-style: italic;">No Diagnosis Reported</span>
          <b-row v-for="diagnosis in sae_diagnosis" :key="diagnosis">
            <b-col>
              {{ diagnosis }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
     
    </b-modal>

    <b-modal :ref="'sae_report_modal'" size="xl" ok-only>
      <template v-slot:modal-header="{ close }">
        <span>SAE Report - {{ sae_report_title }}</span>  
        <i v-if="inMyGroups(['SAE Report Downloader'])" class="fas fa-download tw-cursor-pointer" @click="downloadReport()"> Download</i>
      </template>

      <pdf
        :src="sae_selected_report"
        v-for="i in numPages"
        :key="i"
        :page="i">
      </pdf>
     
    </b-modal>
   
  </div>
  
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";
import * as moment from 'moment';

import pdf from 'vue-pdf';
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  components: {
    pdf
  },
  data: function() {
    return {
      baseUrl: `/kenya/uploads/`,
      numPages: 4,
      fields: [
        { key: "ae_sae_date", sortable: true, label: "Date" },
        { key: "due_on", label: "Time Elapsed" },
        { key: "received_on", sortable: true, label: "Received On" },
        // { key: "compound", label: "Compound"},
        // { key: "clinic_or_field", sortable: true, label: "Reported From" },
        { key: "ae_sae_id", label: "AE ID" },
        // { key: "severity" },
        { key: "users_acknowledged", label: "Approval Status" },
        { key: "reports", label: "Report"},
        { key: "followup_reports", label: "Followup Report"},
      ],
      perPage: 15,
      totalRows: 1,
      currentPage: 1,
      approved_perPage: 15,
      approved_totalRows: 1,
      approved_currentPage: 1,
      tabIndex: 0,
      events: [],
      team_events: [],
      approved_events: [],
      countdown_timers: [],
      approved_countdown_timers: [],
      ack_countdown_timers: [],
      sae_data: null,
      sae_symptoms: null,
      sae_diagnosis: null,
      sae_selected_report: null,
      sae_report_download: null,
      sae_report_title: null,
      excluded_list: [
        'subject_case',
        'users_acknowledged',
        'due_on',
        'users_acknowledged',
        'ack_complete',
        'ack_completed_on',
        'symptoms',
        'closed',
        'case_final_status_complete',
        'sae_reported_on',
        'index',
        'diagnosis',
        'created_from_gps',
        'is_ae_sae',
        'opened_date',
        'subject_barcode_id',
        'ae_sae_date',
        'sum_outcomes_ongoing'
      ],
      field_translations: {
        "this_symptom_display": "Symptom",
        "start_date_symptom": "Start Date",
        "end_date_symptom": "End Date",
        "this_diagnosis_display": "Diagnosis",
        "connected_symptom_display": "Connected Symptom",
        "sum_outcomes_anomaly_or_birth_defect": "Congenital anomaly or birth defect",
        "sum_outcomes_death": "Death",
        "sum_outcomes_disability_or_incapacity": "Persistent or significant disability or incapacity",
        "sum_outcomes_hospital_in": "Referred to Hospital for In-Patient Care",
        "sum_outcomes_hospital_out": "Referred to Hospital for Out-Patient Care",
        "sum_outcomes_life_threatening": "Life threatening",
        "dismissed": "Dismissed",
        "ae_sae_id": "SAE ID",
        "connected_compound": "Compound ID",
        "adverse_event_resolved": "Resolved",
        "last_updated_date": "Last Updated",
        "subject_id": "Subject ID",
        "opened_date": "Created On",
        'id': 'Case ID',
        'subject_barcode_id': 'Subject Barcode',
        'subject_withdrawn': 'Subject Withdrawn',
        'field_or_clinic': 'Last Seen At',
        'ae_sae_date': 'SAE Date',
        'received_on': 'Created On'
      },
      // Table sort controls vars:
      your_sortBy: "ae_sae_date",
      your_sortDesc: true,
      team_sortBy: "ae_sae_date",
      team_sortDesc: true,
      ack_sortBy: "ae_sae_date",
      ack_sortDesc: true,
    };
  },
  computed: {
    ...mapGetters("user", ['inMyGroups']),
  },
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/adverse_events/get_sae_list").then(response => {
      for(var i = 0; i < response.data.length; i++){
        // format the received on timestamp
        var date = moment(response.data[i].opened_date);
        response.data[i].received_on = date;
        let user_approved = false;
        let team_approved = true;

        for(var j = 0; j < response.data[i].users_acknowledged.length; j++){
          // did they acknowledge yet?
          if(response.data[i].users_acknowledged[j].ack | !this.inMyGroups(['Required SAE Acknowledgement'])){
            // calculate the time difference
            var received_on = new Date(Date.parse(response.data[i].opened_date));
            var completed_on = new Date(Date.parse(response.data[i].users_acknowledged[j].timestamp));
            var date_string = 'Acknowledged ' + that.generate_time_difference_string(received_on, completed_on) + ' after event was received.';
            response.data[i].users_acknowledged[j].timestamp = date_string;
            user_approved = true;
          }
          else{
            team_approved = false;
            that.countdown_timers.push({
              display: '',
              past_due: false
            });
          }
        }

        if(user_approved){
          that.approved_countdown_timers.push({
            display: '',
            past_due: false
          })
        }
        if(response.data[i].user_ack){
          // did the team ack?
          // if(response.data[i].ack_complete){  // ack_complete isn't really being set properly on the back end
          if(that.isAcknowledged(response.data[i])){
            that.approved_events.push(response.data[i]);
          }
          else{
            that.team_events.push(response.data[i]);
          }
        }
        else{
          that.events.push(response.data[i]);
        }
      }
      //that.events = response.data;
      that.totalRows = that.events.length;
      that.approved_totalRows = that.approved_events.length;

      if(that.events.length > 0){
        that.tabIndex = 0;
      }

      // console.log(that.approved_countdown_timers.length);

      this.update_countdown();
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('adverseevents', 
            ['getSeriousAdverseEventsCount', 'setSeriousAdverseEventsCount']),

    refreshSideNavCount(){
      this.getSeriousAdverseEventsCount().then((response) => {
                this.setSeriousAdverseEventsCount(response.data);
            });
    },
    isAcknowledged(saeEvent) {
      let ack_array = [];
      saeEvent.users_acknowledged.forEach(function(obj) {
        ack_array.push(obj.ack);
      });
      if(ack_array.includes(false)) {
        return false;
      } else {
        return true;
      }
    },
    downloadReport() {
        const that = this;
        const d = new Date();
        let time = d.getTime();
        let item = this.sae_report_download;

        let downloadUrl = `${that.baseUrl}${item.id}?rand=${time}`;
        HTTP.get(downloadUrl, { responseType: "arraybuffer" })
            .then((response) => {
                var fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                var fileLink = document.createElement("a");
                fileLink.href = fileURL;
                fileLink.setAttribute("download", item.upload);
                document.body.appendChild(fileLink);
                fileLink.click();
            })
            .catch((error) => {
                HandleErrors.HandleErrors(error);
            });
    },
    view_report(item){
      const d = new Date();
      let time = d.getTime();
      let downloadUrl = `${this.baseUrl}${item.id}?rand=${time}`;
      HTTP.get(downloadUrl, { responseType: "arraybuffer" })
        .then((response) => {
          this.sae_report_title = item.title;
          this.sae_selected_report = response;
          this.sae_report_download = item;
          console.log(response);
        });
      // this.sae_selected_report = `${this.baseUrl}${item.id}?rand=${time}`;
      // console.log(this.sae_selected_report);
      this.$refs[('sae_report_modal')].show();
    },
    rowClickableClass(item){
      if(item.ack_required == true && item.user_ack == false){
        return 'clickable';
      }
      return;
    },
    showModal() {
        this.$refs[('sae_modal')].show();
      },
    acknowledge: function(sae_data){
      let that = this;
      
      HTTP.post("/kenya/adverse_events/"+that.events[sae_data.index].id+"/", {
        status: 'acknowledge'
      }).then((response) => {
          response.data.received_on = moment(response.data.opened_date);

          // which do we add it to?

          if(response.data.all_others_ack){
            that.approved_events.unshift(response.data);
          }
          else{
            that.team_events.unshift(response.data);
          }
          that.events.splice(sae_data.index, 1);

          that.refreshSideNavCount();
      });

    }, 
    generate_time_difference_string: function(start, end){
        var diff = (start - end);

        var date_string = '';

        // calculate days
        // var days = parseFloat(diff) / parseFloat(60*60*24*1000);
        // if(days < 0){
        //   date_string += Math.trunc(days) + ':';
        // }
        
        // calculate hours
        // var remainder = days % Math.trunc(days);
        // if(Math.abs(days) < 1){
        //   remainder = days;
        // }

        var hours = parseFloat(diff) / (60*60*1000); //remainder * 24;
        var remainder = 0;
        var str_hours = Math.abs(Math.trunc(hours));
        // if(Math.abs(hours) < 10){
        //   str_hours = "0" + Math.abs(Math.trunc(hours));
        // }
        if(str_hours > 1){
          date_string += str_hours + ' hours<br />';
        }
        else{
          date_string += str_hours + ' hour<br />';
        }

        // calculate minutes
        if(Math.abs(hours) < 1){
          remainder = hours;
        }
        else{
          remainder = hours % Math.trunc(hours);
        }
        var minutes = remainder * 60;
        var str_mins = Math.abs(Math.trunc(minutes));
        if(Math.abs(minutes) < 10){
          str_mins = "0" + Math.abs(Math.trunc(minutes));
        }

        if(parseInt(str_mins) > 1){
          date_string += str_mins + ' minutes';
        }
        else{
          date_string += str_mins + ' minute';
        }
        

        return date_string;
    },
    in_english_please: function(field_name){
      if(field_name in this.field_translations){
        return this.field_translations[field_name];
      }
      return field_name;
    },

    filter: function(key, item){
      if(key.indexOf('sae_flag_') == 0){
        return false
      }
      if(key.indexOf('sum_outcomes') == 0){
        if(item == 0){
          return false
        }
      }
      if(key.indexOf('reports') == 0){
        return false
      }
      return true
    },

    update_countdown: function(){
      let that = this;
      // run through each count down timer and update its contents
      var now = new Date();
      var due_on, date_string, diff, past_due, display_text, completed_on = null;
        
      //date_string = that.generate_time_difference_string(due_on, now);
      diff = (due_on - now);
      past_due = false;

      for(var i = 0; i < that.events.length; i++){
        // first check to see if this event's acknowledgements are compelted
        if(that.events[i].ack_complete == true){
          due_on = new Date(Date.parse(that.events[i].due_on));
          completed_on = new Date(Date.parse(that.events[i].ack_completed_on));

          past_due = false;
          display_text = 'Complete'
          // were we past due?
          if(completed_on > due_on){
            past_due = true;
            display_text += ' (' + that.generate_time_difference_string(due_on, completed_on) + ' past due)';
          }
          that.countdown_timers.splice(i, 1, {
            display: display_text,
            past_due: past_due
          });
          continue;
        }

        due_on = new Date(Date.parse(that.events[i].opened_date));
        
        date_string = that.generate_time_difference_string(due_on, now);
        diff = (due_on - now);
        past_due = false;
        if(diff < 0){
          past_due = true;
          // date_string += ' past due!'
        }

        if(that.events[i])
        that.countdown_timers.splice(i, 1, {
          display: date_string,
          past_due: past_due
        });
      }

      for(i = 0; i < that.team_events.length; i++){
        // first check to see if this event's acknowledgements are compelted
        if(that.team_events[i].ack_complete == true){
          due_on = new Date(Date.parse(that.team_events[i].due_on));
          completed_on = new Date(Date.parse(that.team_events[i].ack_completed_on));

          past_due = false;
          display_text = 'Complete'
          // were we past due?
          if(completed_on > due_on){
            past_due = true;
            display_text += ' (' + that.generate_time_difference_string(due_on, completed_on) + ' past due)';
          }
          that.approved_countdown_timers.splice(i, 1, {
            display: display_text,
            past_due: past_due
          });
          continue;
        }

        due_on = new Date(Date.parse(that.team_events[i].opened_date));
        
        date_string = that.generate_time_difference_string(due_on, now);
        diff = (due_on - now);
        past_due = false;
        if(diff < 0){
          past_due = true;
          // date_string += ' past due!'
        }

        if(that.team_events[i])
        that.approved_countdown_timers.splice(i, 1, {
          display: date_string,
          past_due: past_due
        });
      }

      for(i = 0; i < that.approved_events.length; i++){
        // first check to see if this event's acknowledgements are compelted
        if(that.approved_events[i].ack_complete == true){
          due_on = new Date(Date.parse(that.approved_events[i].due_on));
          completed_on = new Date(Date.parse(that.approved_events[i].ack_completed_on));

          past_due = false;
          display_text = 'Complete'
          // were we past due?
          if(completed_on > due_on){
            past_due = true;
            display_text += ' (' + that.generate_time_difference_string(due_on, completed_on) + ' past due)';
          }
          that.ack_countdown_timers.splice(i, 1, {
            display: display_text,
            past_due: past_due
          });
          continue;
        }

        due_on = new Date(Date.parse(that.approved_events[i].opened_date));
        
        date_string = that.generate_time_difference_string(due_on, now);
        diff = (due_on - now);
        past_due = false;
        if(diff < 0){
          past_due = true;
          // date_string += ' past due!'
        }

        if(that.approved_events[i])
        that.ack_countdown_timers.splice(i, 1, {
          display: date_string,
          past_due: past_due
        });
      }
      setTimeout(that.update_countdown, 10000);
    },

    rowClicked(record, index){
      let that = this;
      // ignore if they've already acknowledged
      if(record.user_ack || !record.ack_required){
        return;
      }

      HTTP.get("/kenya/serious_event_details/"+record.id+"/").then(response => {
        that.sae_data = {};
        for(var key in response.data){
          if(that.excluded_list.indexOf(key) == -1){
            that.sae_data[key] = response.data[key];
          }
        }
        //that.sae_data = response.data;
        that.sae_data.received_on = moment(response.data.opened_date);

        that.sae_symptoms = [];
        for(var i = 0; i < response.data.symptoms.length; i++){
          that.sae_symptoms.push({
            'display': response.data.symptoms[i].this_symptom_display,
            'start': response.data.symptoms[i].start_date_symptom,
            'end': response.data.symptoms[i].end_date_symptom
          });
        }

        that.sae_diagnosis = [];
        for(i = 0; i < response.data.diagnosis.length; i++){
          that.sae_diagnosis.push(response.data.diagnosis[i].this_diagnosis_display + ' ('+response.data.diagnosis[i].connected_symptom_display+')');
        }
        that.sae_data.index = index;
        // otherwise, show the ack modal
        this.showModal();
      });
    }
  }
};
</script>

<style>
.clickable {
  cursor: pointer;
}
</style>